<form autocomplete="off" [formGroup]="formUsr" (ngSubmit)="save()">
    <h4>Detalle cuenta usuario

    </h4>
    <hr>
    <div class="form-group row">
        <div class="textOnInput col-12 col-md-4">
            <label class="form-label">Nombre</label>
            <input class="form-control" formControlName="name" type="text" placeholder="Ingrese nombre(s)" id="name">
        </div>
        <div class="textOnInput col-12 col-md-4">
            <label class="form-label">Apellido paterno</label>
            <input class="form-control" formControlName="lastname" type="text" placeholder="Apellido paterno"
                id="lastname">
        </div>
        <div class="textOnInput col-12 col-md-4">
            <label class="form-label">Apellido materno</label>
            <input class="form-control" formControlName="surname" type="text" placeholder="Apellido materno"
                id="surname">
        </div>

        <div class="textOnInput col-12 col-md-6">
            <label class="form-label">Email</label>
            <input class="form-control" formControlName="email" type="email" placeholder="Email" id="email"
                autocomplete="new-password" [class.is-invalid]="campoNoValido('email')">
            <small class="text-danger" *ngIf="campoNoValido('email')">Ingrese un correo válido</small>
        </div>

        <div class="textOnInput col-12 col-md-6">
            <label class="form-label">Password</label>
            <input class="form-control" formControlName="pass" type="password" placeholder="Password" id="password"
                autocomplete="new-password">
        </div>

        <div class="textOnInput col-4 col-md-4">
            <label class="form-label">Rol</label>
            <select class="form-select form-input" formControlName="idrol" [class.is-invalid]="campoNoValido('idrol')">
                <option selected disabled value="null">Seleccione un rol ...</option>
                <option *ngFor="let rol of roles" value="{{rol.id}}">
                    {{rol.label}}
                </option>
            </select>
            <small class="text-danger" *ngIf="campoNoValido('idrol')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Estado</label>
            <div class="label-container align-switch">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="switch1" formControlName="isActive">
                </div>
            </div>
        </div>

    </div>

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="submit" class="btn btn-outline-secondary  btn-block"
                        [routerLink]="['/adm/usuarios/list']">
                        Cancelar
                    </button>
                </div>
                <div>
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </div>
            </div>
        </div>
    </div>

</form>